import React from 'react'
import { useEffect } from 'react'
import FlagIcon from '../../../basic-components/flag-icon';
import cs from './styles.pcss';
import SelectField from '../../../basic-components/select-field/index';
import t from '../shipping-packet/locale'
import t1 from '../shipping-container/locale'
import t2 from '../locale'
import { transformToDropdownOptions, getRegionNames } from '../profile-utils';
import { getShippingServiceDictionaryBySiteId } from "../../shipping-profile-lightbox/profile-utils"
import Icon from '../../../basic-components/icon';
import { getCurrencySymbol } from "../../../utils/countries"
import useMediaQuery from "../../../hooks/use-media-query"
import { FormField } from "../../../hocs/final-form"
import PricesNew from "../prices-new"
import classNames from 'classnames/bind';
import Input from '../../../basic-components/input';
import Button from '../../../basic-components/button';

const cx = classNames.bind(cs);



export const countryMapping = {
  us: { label: 'ebay.com', siteCode: 'US', currency: "USD", siteId: "0" },
  uk: { label: 'ebay.co.uk', siteCode: 'UK', currency: "GBP", siteId: "3" },
  de: { label: 'ebay.de', siteCode: 'DE', currency: "EUR", siteId: "77" },
  fr: { label: 'ebay.fr', siteCode: 'FR', currency: "EUR", siteId: "71" },
  it: { label: 'ebay.it', siteCode: 'IT', currency: "EUR", siteId: "101" },
  es: { label: 'ebay.es', siteCode: 'ES', currency: "EUR", siteId: "186" },
  au: { label: 'ebay.com.au', siteCode: 'AU', currency: "AUD", siteId: "15" },
  ca: { label: 'ebay.ca', siteCode: 'CA', currency: "CAD", siteId: "2" },
  worldwide: { label: 'Worldwide', siteCode: 'worldwide', currency: "USD", siteId: "-1" },
};

export default function flagSiteCurrencyMarker(props) {
  const { countryCode, field, fields, onDelete, profile, index, isNew, countryIsCollapse, domesticShippingServices2,worldwideCurrency } = props;
  const firstDomesticShipping = index === 0;
  const siteId = countryMapping[countryCode].siteId + "";
  const veryLargeScreen = useMediaQuery(`(min-width: 1280px)`);
  // 每个站点可选择的国内和国际services
  const shippingServiceDictionary = getShippingServiceDictionaryBySiteId(
    profile?.domesticShippingServices || [],
    siteId
  );


  // 显示可选service
  const dropdownOptions = transformToDropdownOptions(shippingServiceDictionary);
  const worldwideOptions = [
    { value: "ECONOMY", label: "ECONOMY" },
    { value: "STANDARD", label: "STANDARD" },
    { value: "EXPEDITED", label: "EXPEDITED" },
    { value: "EXPRESS", label: "EXPRESS" },
    { value: "UNSET", label: "-" }
  ]
  const dropdownOptions2 = transformToDropdownOptions(domesticShippingServices2?.filter(item => item.site_id == countryMapping[countryCode].siteId) || []);

  const deleteButton = (
    <button
      type="button"
      onClick={onDelete}
      className={cx('removeTariff')}
    >
      <Icon name="trash" />
    </button>
  );





  return (
    <div style={{ display: 'flex', justifyContent: "flex-start", alignItems: 'flex-start' }} >
      {(countryIsCollapse[countryCode] || index == 0) && <div className={cs.fieldClassName} style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'center', width: '210px', height: "100%", fontWeight: 700, marginTop: '14px' }} >
        {
          (firstDomesticShipping) ? (<div style={{ display: 'flex', justifyContent: "flex-start", alignItems: 'center', width: "100%", gap: '10px' }}> {countryCode != 'worldwide' && <FlagIcon
            name={(countryMapping[countryCode].siteCode + "")}
            wrapperClassName={cs.flagIcon}
          />}
          {/* worldwideCurrency */}
            <span>{countryMapping[countryCode].label}</span>
            <span>{countryCode != 'worldwide'?countryMapping[countryCode].currency:worldwideCurrency}</span>
            <span>{getCurrencySymbol(countryCode != 'worldwide'?countryMapping[countryCode].currency:worldwideCurrency)}</span>
          </div>) : null
        }
      </div>}
      <div className='right' style={{ cursor: 'auto', paddingRight: '0px' }} onClick={e => {
        e.stopPropagation()
      }}>
        {(countryIsCollapse[countryCode] || index == 0) && <div className={cs.firstLine} style={{ flex: 1, display: 'flex', justifyContent: "flex-start", alignItems: 'center', gap: '10px', marginBottom: '28px' }} >

          <div style={{ display: 'flex',  flexDirection: 'row' }}>

            <FormField
              name={(countryCode == "worldwide")?(`${field}.shipping_level`):(`${field}.shipping_service`)}
              Component={SelectField}
              options={countryCode == 'worldwide'?worldwideOptions:(isNew?dropdownOptions2:dropdownOptions2)}
              placeholder={t2('ShippingServicePlaceholder')}
              grid={9}
              noLabel
              searchable
              validate={(val) =>{
                if((!val || !val.trim())&&(countryCode !== "worldwide")){
                  return   t2('shippingServiceCannotBeBlankPlsChoose')
                }
                return null
              }
              }
              errorClassName={cs.errorClassName}
              fieldClassName={cs.fieldClassName}
              onChange={({ value }) => {
                if(countryCode == "worldwide"){
                  fields.update(index,{...fields.value[index],shipping_level:value})
                }else{
                  fields.update(index,{...fields.value[index],shipping_service:value})
                }
                return value
              }}
            />

            <div style={{ marginTop: '0px' }}>
              <PricesNew noLabel={true} additionalPriceML10={true} field={field} defaultCurrency={countryMapping[countryCode].currency} description={!firstDomesticShipping && deleteButton} onDelete={onDelete} profile={profile} firstDomesticShipping={firstDomesticShipping}
                freeShipping={profile?.['tariffsNew']?.[countryCode]?.[index]?.cost?.free}
                countryCode={countryCode}
                index={index}
                fields={fields}
              ></PricesNew>
            </div>
          </div>
        </div>}
      </div>
    </div>
  )
}
